export default __webpack_public_path__ + "static/media/develop_mound.66272fa4.png";